import { StyledContainer } from '@zg-rentals/zrs-comet';
import styled, { css, keyframes } from 'styled-components';

const skeletonShimmer = keyframes`
    0% {
        opacity: 0.5;
    }
    100% {
        opacity: 1;
    }
`;

export const StyledContainerWrapper = styled(StyledContainer)`
  animation: ${skeletonShimmer} 600ms linear infinite forwards alternate;

  ${(props) =>
    // @ts-expect-error
    props.$isCover &&
    css`
      height: 100%;
      width: 100%;
    `}

  ${(props) =>
    // @ts-expect-error
    props.$isLight &&
    css`
      background-color: #fff;
    `}

    ${(props) =>
    // @ts-expect-error
    props.$isDark &&
    css`
      background-color: #ddd;
    `}

    ${(props) =>
    // @ts-expect-error
    props.$isFloatRight &&
    css`
      float: right;
    `}

    ${(props) =>
    // @ts-expect-error
    props.$type === 'bar' &&
    css`
      height: 40px;
      width: 100%;
    `}

    ${(props) =>
    // @ts-expect-error
    props.$type === 'line' &&
    css`
      height: 20px;
      width: 100%;
    `}

    ${(props) =>
    // @ts-expect-error
    props.$type === 'box' &&
    css`
      height: 200px;
      width: 300px;
    `}

    ${(props) =>
    // @ts-expect-error
    props.$type === 'badge' &&
    css`
      height: 25px;
      width: 90px;
    `}

    ${(props) =>
    // @ts-expect-error
    props.$type === 'chatBubble' &&
    css`
      height: 30px;
      border-radius: 3px;
    `}
    
    ${(props) =>
    // @ts-expect-error
    props.$type === 'chatBubble' &&
    // @ts-expect-error
    props.$isFloatRight &&
    css`
      width: 350px;
    `}
`;
